/**
 * @generated SignedSource<<bb22558da2c5979a29cb11b72aa4080b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type agileTutorialTwoQuery$variables = {
  limit?: number | null | undefined;
  locale: string;
  urlSlug: string;
};
export type agileTutorialTwoQuery$data = {
  readonly tutorialDetailsCollection: {
    readonly items: ReadonlyArray<{
      readonly contentHubSubscribeCollection: {
        readonly items: ReadonlyArray<{
          readonly ctaButtonText: string | null | undefined;
          readonly subscribeComponentName: string | null | undefined;
          readonly successMessage: string | null | undefined;
          readonly valueProposition: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly nextBestActionCollection: {
        readonly items: ReadonlyArray<{
          readonly __typename: "MicrositeArticle";
          readonly articleBanner: {
            readonly contentType: string | null | undefined;
            readonly description: string | null | undefined;
            readonly fileName: string | null | undefined;
            readonly height: number | null | undefined;
            readonly size: number | null | undefined;
            readonly title: string | null | undefined;
            readonly url: string | null | undefined;
            readonly width: number | null | undefined;
          } | null | undefined;
          readonly articleName: string | null | undefined;
          readonly description: string | null | undefined;
          readonly title: string | null | undefined;
          readonly urlSlug: string | null | undefined;
        } | {
          readonly __typename: "Tutorial";
          readonly description: string | null | undefined;
          readonly name: string | null | undefined;
          readonly title: string | null | undefined;
          readonly tutorialBanner: {
            readonly contentType: string | null | undefined;
            readonly description: string | null | undefined;
            readonly fileName: string | null | undefined;
            readonly height: number | null | undefined;
            readonly size: number | null | undefined;
            readonly title: string | null | undefined;
            readonly url: string | null | undefined;
            readonly width: number | null | undefined;
          } | null | undefined;
          readonly urlSlug: string | null | undefined;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined>;
      } | null | undefined;
      readonly productDiscussedCtaCollection: {
        readonly items: ReadonlyArray<{
          readonly asset: {
            readonly contentType: string | null | undefined;
            readonly description: string | null | undefined;
            readonly fileName: string | null | undefined;
            readonly height: number | null | undefined;
            readonly size: number | null | undefined;
            readonly title: string | null | undefined;
            readonly url: string | null | undefined;
            readonly width: number | null | undefined;
          } | null | undefined;
          readonly dataBlueprintModule: string | null | undefined;
          readonly productCollection: {
            readonly items: ReadonlyArray<{
              readonly icon: {
                readonly contentType: string | null | undefined;
                readonly description: string | null | undefined;
                readonly fileName: string | null | undefined;
                readonly height: number | null | undefined;
                readonly size: number | null | undefined;
                readonly title: string | null | undefined;
                readonly url: string | null | undefined;
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly productNameReference: {
                readonly productName: string | null | undefined;
              } | null | undefined;
            } | null | undefined>;
          } | null | undefined;
          readonly text: string | null | undefined;
          readonly title: string | null | undefined;
          readonly url: string | null | undefined;
          readonly valueProposition: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly relatedHubCollection: {
        readonly items: ReadonlyArray<{
          readonly description: {
            readonly json: any;
          } | null | undefined;
          readonly shortDescriptionOneLiner: string | null | undefined;
          readonly title: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly relatedProductFeaturesCollection: {
        readonly items: ReadonlyArray<{
          readonly _id: string;
          readonly description: {
            readonly json: any;
          } | null | undefined;
          readonly name: string | null | undefined;
          readonly shortDescriptionOneLiner: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly relatedTemplateCtaCollection: {
        readonly items: ReadonlyArray<{
          readonly productCollection: {
            readonly items: ReadonlyArray<{
              readonly productNameReference: {
                readonly productName: string | null | undefined;
              } | null | undefined;
            } | null | undefined>;
          } | null | undefined;
          readonly text: string | null | undefined;
          readonly title: string | null | undefined;
          readonly url: string | null | undefined;
          readonly valueProposition: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly shareThisTutorialCollection: {
        readonly items: ReadonlyArray<{
          readonly socialMediaChannel: {
            readonly socialMediaChannel: string | null | undefined;
          } | null | undefined;
          readonly socialMediaHandle: string | null | undefined;
          readonly socialMediaUrl: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly upNext: {
        readonly __typename: "MicrositeArticle";
        readonly articleBanner: {
          readonly contentType: string | null | undefined;
          readonly description: string | null | undefined;
          readonly fileName: string | null | undefined;
          readonly height: number | null | undefined;
          readonly name: string | null | undefined;
          readonly size: number | null | undefined;
          readonly url: string | null | undefined;
          readonly width: number | null | undefined;
        } | null | undefined;
        readonly articleName: string | null | undefined;
        readonly articleTitle: string | null | undefined;
        readonly description: string | null | undefined;
        readonly urlSlug: string | null | undefined;
      } | {
        readonly __typename: "Tutorial";
        readonly description: string | null | undefined;
        readonly tutorialBanner: {
          readonly contentType: string | null | undefined;
          readonly description: string | null | undefined;
          readonly fileName: string | null | undefined;
          readonly height: number | null | undefined;
          readonly name: string | null | undefined;
          readonly size: number | null | undefined;
          readonly url: string | null | undefined;
          readonly width: number | null | undefined;
        } | null | undefined;
        readonly tutorialName: string | null | undefined;
        readonly tutorialTitle: string | null | undefined;
        readonly urlSlug: string | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
      readonly whitePaperCtaCollection: {
        readonly items: ReadonlyArray<{
          readonly dataBlueprintModule: string | null | undefined;
          readonly productCollection: {
            readonly items: ReadonlyArray<{
              readonly productNameReference: {
                readonly productName: string | null | undefined;
              } | null | undefined;
            } | null | undefined>;
          } | null | undefined;
          readonly text: string | null | undefined;
          readonly title: string | null | undefined;
          readonly url: string | null | undefined;
          readonly valueProposition: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
    } | null | undefined>;
  } | null | undefined;
};
export type agileTutorialTwoQuery = {
  response: agileTutorialTwoQuery$data;
  variables: agileTutorialTwoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": 1,
  "kind": "LocalArgument",
  "name": "limit"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locale"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "urlSlug"
},
v3 = [
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "locale",
    "variableName": "locale"
  },
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "urlSlug",
            "variableName": "urlSlug"
          }
        ],
        "kind": "ObjectValue",
        "name": "tutorialRef"
      }
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueProposition",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "TutorialDetailsContentHubSubscribeCollection",
  "kind": "LinkedField",
  "name": "contentHubSubscribeCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SubscribeComponent",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": "subscribeComponentName",
          "args": null,
          "kind": "ScalarField",
          "name": "subscribeComponentNameExternal",
          "storageKey": null
        },
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ctaButtonText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "successMessage",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v7 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "ctaTitleExternal",
  "storageKey": null
},
v8 = {
  "alias": "text",
  "args": null,
  "kind": "ScalarField",
  "name": "ctaText",
  "storageKey": null
},
v9 = {
  "alias": "url",
  "args": null,
  "kind": "ScalarField",
  "name": "ctaUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentType",
  "storageKey": null
},
v17 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  },
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductName",
  "kind": "LinkedField",
  "name": "productNameReference",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "productName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataBlueprintModule",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": (v6/*: any*/),
  "concreteType": "TutorialDetailsProductDiscussedCtaCollection",
  "kind": "LinkedField",
  "name": "productDiscussedCtaCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CallToAction",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v7/*: any*/),
        (v4/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        {
          "alias": "asset",
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "ctaAsset",
          "plural": false,
          "selections": (v17/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v6/*: any*/),
          "concreteType": "CallToActionProductCollection",
          "kind": "LinkedField",
          "name": "productCollection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductListing",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                (v18/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Asset",
                  "kind": "LinkedField",
                  "name": "icon",
                  "plural": false,
                  "selections": (v17/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "productCollection(limit:1)"
        },
        (v19/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "productDiscussedCtaCollection(limit:1)"
},
v21 = {
  "alias": null,
  "args": (v6/*: any*/),
  "concreteType": "CallToActionProductCollection",
  "kind": "LinkedField",
  "name": "productCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductListing",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v18/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "productCollection(limit:1)"
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "TutorialDetailsRelatedTemplateCtaCollection",
  "kind": "LinkedField",
  "name": "relatedTemplateCtaCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CallToAction",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v7/*: any*/),
        (v4/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        (v21/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": (v6/*: any*/),
  "concreteType": "TutorialDetailsWhitePaperCtaCollection",
  "kind": "LinkedField",
  "name": "whitePaperCtaCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CallToAction",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v7/*: any*/),
        (v4/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        (v21/*: any*/),
        (v19/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "whitePaperCtaCollection(limit:1)"
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v25 = {
  "alias": "articleName",
  "args": null,
  "kind": "ScalarField",
  "name": "articleNameExternal",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "articleTitle",
  "storageKey": null
},
v27 = [
  (v10/*: any*/),
  {
    "alias": "name",
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  },
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "articleBanner",
  "plural": false,
  "selections": (v27/*: any*/),
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlSlug",
  "storageKey": null
},
v30 = {
  "alias": "tutorialName",
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialNameExternal",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialTitle",
  "storageKey": null
},
v32 = {
  "alias": "description",
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialDescription",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "tutorialBanner",
  "plural": false,
  "selections": (v27/*: any*/),
  "storageKey": null
},
v34 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 2
  }
],
v35 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "articleTitle",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "articleBanner",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v37 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialNameExternal",
  "storageKey": null
},
v38 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialTitle",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "tutorialBanner",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": (v6/*: any*/),
  "concreteType": "TutorialDetailsShareThisTutorialCollection",
  "kind": "LinkedField",
  "name": "shareThisTutorialCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SocialMediaLink",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "socialMediaHandle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "socialMediaUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ContextSocialMediaChannel",
          "kind": "LinkedField",
          "name": "socialMediaChannel",
          "plural": false,
          "selections": [
            {
              "alias": "socialMediaChannel",
              "args": null,
              "kind": "ScalarField",
              "name": "socialMediaChannelExternal",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "shareThisTutorialCollection(limit:1)"
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortDescriptionOneLiner",
  "storageKey": null
},
v42 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "json",
    "storageKey": null
  }
],
v43 = {
  "alias": null,
  "args": (v6/*: any*/),
  "concreteType": "TutorialDetailsRelatedHubCollection",
  "kind": "LinkedField",
  "name": "relatedHubCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TaxonomyContentHub",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": "title",
          "args": null,
          "kind": "ScalarField",
          "name": "contentHubTitleExternal",
          "storageKey": null
        },
        (v41/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxonomyContentHubDescription",
          "kind": "LinkedField",
          "name": "description",
          "plural": false,
          "selections": (v42/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "relatedHubCollection(limit:1)"
},
v44 = {
  "alias": null,
  "args": (v6/*: any*/),
  "concreteType": "TutorialDetailsRelatedProductFeaturesCollection",
  "kind": "LinkedField",
  "name": "relatedProductFeaturesCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TaxonomyFeature",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "_id",
          "storageKey": null
        },
        {
          "alias": "name",
          "args": null,
          "kind": "ScalarField",
          "name": "featureNameExternal",
          "storageKey": null
        },
        (v41/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxonomyFeatureDescription",
          "kind": "LinkedField",
          "name": "description",
          "plural": false,
          "selections": (v42/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "relatedProductFeaturesCollection(limit:1)"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "agileTutorialTwoQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TutorialDetailsCollection",
        "kind": "LinkedField",
        "name": "tutorialDetailsCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TutorialDetails",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v20/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "upNext",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v10/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/)
                    ],
                    "type": "MicrositeArticle",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v24/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v29/*: any*/)
                    ],
                    "type": "Tutorial",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v34/*: any*/),
                "concreteType": "TutorialDetailsNextBestActionCollection",
                "kind": "LinkedField",
                "name": "nextBestActionCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v35/*: any*/),
                          (v10/*: any*/),
                          (v36/*: any*/),
                          (v29/*: any*/)
                        ],
                        "type": "MicrositeArticle",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v24/*: any*/),
                          (v37/*: any*/),
                          (v38/*: any*/),
                          (v32/*: any*/),
                          (v39/*: any*/),
                          (v29/*: any*/)
                        ],
                        "type": "Tutorial",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "nextBestActionCollection(limit:2)"
              },
              (v40/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "agileTutorialTwoQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TutorialDetailsCollection",
        "kind": "LinkedField",
        "name": "tutorialDetailsCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TutorialDetails",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v20/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "upNext",
                "plural": false,
                "selections": [
                  (v24/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v10/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/)
                    ],
                    "type": "MicrositeArticle",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v29/*: any*/)
                    ],
                    "type": "Tutorial",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v34/*: any*/),
                "concreteType": "TutorialDetailsNextBestActionCollection",
                "kind": "LinkedField",
                "name": "nextBestActionCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v24/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v25/*: any*/),
                          (v35/*: any*/),
                          (v10/*: any*/),
                          (v36/*: any*/),
                          (v29/*: any*/)
                        ],
                        "type": "MicrositeArticle",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v37/*: any*/),
                          (v38/*: any*/),
                          (v32/*: any*/),
                          (v39/*: any*/),
                          (v29/*: any*/)
                        ],
                        "type": "Tutorial",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "nextBestActionCollection(limit:2)"
              },
              (v40/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "857a8a6c9ad3c9de137a8a4d03788327",
    "id": null,
    "metadata": {},
    "name": "agileTutorialTwoQuery",
    "operationKind": "query",
    "text": "query agileTutorialTwoQuery(\n  $limit: Int = 1\n  $urlSlug: String!\n  $locale: String!\n) {\n  tutorialDetailsCollection(limit: $limit, where: {tutorialRef: {urlSlug: $urlSlug}}, locale: $locale) {\n    items {\n      contentHubSubscribeCollection {\n        items {\n          subscribeComponentName: subscribeComponentNameExternal\n          valueProposition\n          ctaButtonText\n          successMessage\n        }\n      }\n      productDiscussedCtaCollection(limit: 1) {\n        items {\n          title: ctaTitleExternal\n          valueProposition\n          text: ctaText\n          url: ctaUrl\n          asset: ctaAsset {\n            title\n            description\n            url\n            width\n            height\n            size\n            fileName\n            contentType\n          }\n          productCollection(limit: 1) {\n            items {\n              productNameReference {\n                productName\n              }\n              icon {\n                title\n                description\n                url\n                width\n                height\n                size\n                fileName\n                contentType\n              }\n            }\n          }\n          dataBlueprintModule\n        }\n      }\n      relatedTemplateCtaCollection {\n        items {\n          title: ctaTitleExternal\n          valueProposition\n          text: ctaText\n          url: ctaUrl\n          productCollection(limit: 1) {\n            items {\n              productNameReference {\n                productName\n              }\n            }\n          }\n        }\n      }\n      whitePaperCtaCollection(limit: 1) {\n        items {\n          title: ctaTitleExternal\n          valueProposition\n          text: ctaText\n          url: ctaUrl\n          productCollection(limit: 1) {\n            items {\n              productNameReference {\n                productName\n              }\n            }\n          }\n          dataBlueprintModule\n        }\n      }\n      upNext {\n        __typename\n        ... on MicrositeArticle {\n          __typename\n          articleName: articleNameExternal\n          articleTitle\n          description\n          articleBanner {\n            description\n            name: title\n            url\n            width\n            height\n            size\n            fileName\n            contentType\n          }\n          urlSlug\n        }\n        ... on Tutorial {\n          __typename\n          tutorialName: tutorialNameExternal\n          tutorialTitle\n          description: tutorialDescription\n          tutorialBanner {\n            description\n            name: title\n            url\n            width\n            height\n            size\n            fileName\n            contentType\n          }\n          urlSlug\n        }\n      }\n      nextBestActionCollection(limit: 2) {\n        items {\n          __typename\n          ... on MicrositeArticle {\n            __typename\n            articleName: articleNameExternal\n            title: articleTitle\n            description\n            articleBanner {\n              title\n              description\n              url\n              width\n              height\n              size\n              fileName\n              contentType\n            }\n            urlSlug\n          }\n          ... on Tutorial {\n            __typename\n            name: tutorialNameExternal\n            title: tutorialTitle\n            description: tutorialDescription\n            tutorialBanner {\n              title\n              description\n              url\n              width\n              height\n              size\n              fileName\n              contentType\n            }\n            urlSlug\n          }\n        }\n      }\n      shareThisTutorialCollection(limit: 1) {\n        items {\n          socialMediaHandle\n          socialMediaUrl\n          socialMediaChannel {\n            socialMediaChannel: socialMediaChannelExternal\n          }\n        }\n      }\n      relatedHubCollection(limit: 1) {\n        items {\n          title: contentHubTitleExternal\n          shortDescriptionOneLiner\n          description {\n            json\n          }\n        }\n      }\n      relatedProductFeaturesCollection(limit: 1) {\n        items {\n          _id\n          name: featureNameExternal\n          shortDescriptionOneLiner\n          description {\n            json\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "341a554120697e28ab93357a825597e6";

export default node;
